module.exports = __webpack_public_path__ + "img/xhs.2b5b310c.png";